import * as React from 'react'
// constants
import { CLOSED_DRAWER_WIDTH, DRAWER_WIDTH } from 'constants/layout'
import { LinkingModeContext } from 'containers/Plan/Edit/layers/API/Linking'
// utils
import isFunction from 'lodash/isFunction'

type Props = React.PropsWithChildren<unknown>

interface IContext {
  isDrawerExpanded: boolean
  offset: number
  toggleDrawer: () => void
}

export const MainLayoutAPIContext = React.createContext<IContext>({} as any)

const MainLayoutAPI: React.FC<Props> = ({ children }) => {
  const [toggled, setToggled] = React.useState<boolean>(false)

  const { handleSetIsOpen } = React.useContext(LinkingModeContext)

  React.useEffect(() => {
    if (isFunction(handleSetIsOpen)) {
      handleSetIsOpen(toggled)
    }
  }, [toggled])

  const toggleDrawer = () => setToggled((prev) => !prev)

  const offset = toggled ? DRAWER_WIDTH : CLOSED_DRAWER_WIDTH

  const value = { isDrawerExpanded: toggled, offset, toggleDrawer }

  return <MainLayoutAPIContext.Provider value={value}>{children}</MainLayoutAPIContext.Provider>
}

export default MainLayoutAPI
